import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

const NOTIFICATION_SETTINGS_KEY = 'notification-settings';

export interface NotificationSettingsResponse {
  reminder_subscribed: boolean;
  shift_reminder_subscribed: boolean;
  autofill_notification_schedule: boolean;
  shift_notification_time: string | null;
  shift_notification_weekdays: number[] | null;
}

export function useNotificationSettings() {
  return useQuery<NotificationSettingsResponse>({
    queryKey: [NOTIFICATION_SETTINGS_KEY],
    queryFn: () => baseFetcher(apiRoutes.notificationSettings()),
  });
}

export function useUpdateNotificationSettings() {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, Partial<NotificationSettingsResponse>>({
    mutationFn: (data) =>
      baseFetcher(apiRoutes.notificationSettings(), {
        method: 'PATCH',
        data,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTIFICATION_SETTINGS_KEY] });
    },
  });
}
